module.exports = __webpack_public_path__ + "static/determined-collapsed-5-ddc2fdfc31f21d35c4e359d16748ba73.png";